const identifySourceVideo = (link) => {
  if (link.includes('vimeo')) {
    return 'Vimeo'
  }
  return 'Other'
}

const getVideoIdVimeo = (link) => {
  return link.substring(link.lastIndexOf('/') + 1)
}

export { identifySourceVideo, getVideoIdVimeo }
